import React from 'react';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import ErrorPage from 'next/error';
import { useTranslation } from 'next-i18next';
import { useRouter } from 'next/router';
import {
  getPosts,
  getCategoriess,
} from '../../../../../utils/api/wordpress-api';
import ArticlesSubHeader from '../../../../../components/Articles/SubHeader';
import ArticlesMain from '../../../../../components/Articles/Main';
import BlogSEO from '../../../../../components/SEO/ForBlog';
import { checkLocaleAllowed } from '../../../../blog';

interface Props {
  posts: any;
  categories: any[];
  pageContext: any;
  page: number;
}

function Index({ posts: { edges }, categories, pageContext, page }: Props) {
  const { t } = useTranslation('blog');
  const router = useRouter();
  const { locale } = router;
  if (!checkLocaleAllowed(locale)) {
    return <ErrorPage statusCode={404} />;
  }

  return (
    <>
      <BlogSEO
        title={t('title.categoryPage', {
          category: pageContext.category,
          pageNum: page,
        })}
      />
      <ArticlesSubHeader categories={categories} />
      <ArticlesMain posts={edges} pageContext={pageContext} locale={locale} />
    </>
  );
}

export async function getServerSideProps({ locale = 'en', query }) {
  const { category, page } = query;
  const offset = (page - 1) * 10;
  const posts = await getPosts(
    {
      offset,
      category,
    },
    locale,
  );
  const categoriesData = await getCategoriess(locale);
  const basePath = '/blog/category/[category]';
  const baseAsPath = `/blog/category/${category}`;
  return {
    props: {
      ...(await serverSideTranslations(locale, ['common', 'blog'])),
      page,
      posts,
      preview: false,
      categories: categoriesData.categories,
      pageContext: {
        totalCount: posts.pageInfo.offsetPagination.total,
        limit: 10,
        skip: offset,
        filter: null,
        searchTerm: null,
        basePath,
        baseAsPath,
        category,
      },
    },
  };
}

export default Index;
